import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

interface SiTrackSnackbarProps {
  open: boolean;
  message: string;
  severity?: any;
  onClose: () => void;
}

const Alert = (props: any) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

export default function SiTrackSnackbar({ open, message, severity, onClose }: SiTrackSnackbarProps) {
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose();
  };

  // const requiredItems: string[] = [];
  // const otherItems: string[] = [];

  // const items = message?.split(',')?.map((item) => item?.trim());
  // Array.isArray(items) &&
  //   items?.forEach((item) => {
  //     if (item?.toLowerCase()?.includes('is required')) {
  //       requiredItems?.push(item?.split(' is required')[0]?.trim());
  //     } else {
  //       otherItems?.push(item);
  //     }
  //   });

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={{ zIndex: 10000000 }}
    >
      <div>
        <Alert severity={severity} variant="filled" sx={{ width: '100%' }} onClose={handleClose}>
          {message}
          {/* <div>
            {requiredItems.length > 0 && 'Required Item'}
            {requiredItems.length > 0 && (
              <ul>
                {requiredItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
            {otherItems.length > 0 && (
              <ul>
                {otherItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
          </div> */}
        </Alert>
      </div>
    </Snackbar>
  );
}
